export default __webpack_public_path__ + "static/media/Eco1.0cd792de.png";